import Heidelberg from '../plugins/heidelberg-plugin.js'

module.exports = {
  props: ['images'],
  data () {
    return {
      visible: false,
      previewImages: 1,
      currentIndex: 0,
      showLookInside: true
    }
  },
  mounted () {
    new Heidelberg($('#book-preview'), {
      canClose: true
    })
  },
  methods: {
    open () {
      this.visible = true
    },
    close () {
      this.visible = false
    },

    lazyLoading (index) {
      this.currentIndex = index
      this.showLookInside = index === 1

      if (index === 0 && this.previewImages < 8) this.previewImages = 4
      if (index === 2 && this.previewImages < 8) this.previewImages = 8
      if (index === 6 && this.previewImages < 14) this.previewImages = 14
      if (index === 10 && this.previewImages < 20) this.previewImages = 20
      if (index === 16 && this.previewImages < 26) this.previewImages = 26
      if (index === 22 && this.previewImages < 32) this.previewImages = 32
      if (index === 28 && this.previewImages < 38) this.previewImages = 38
      if (index === 34 && this.previewImages < 45) this.previewImages = 45
    },

    url (image, index) {
      return this.previewImages >= index ? image : ''
    },

    backface (index) {
      return this.currentIndex === index || this.currentIndex + 1 === index || this.currentIndex - 1 === index || this.currentIndex + 2 === index || this.currentIndex - 2 === index ? 'backface-hidden' : ''
    },

    wasVisible (index) {
      return this.currentIndex - 4 > index ? 'd-none' : ''
    }
  },
  template: `
    <div class="relative -z-1">
      <div class="flex justify-content-center align-items-center">
          <div class="book-preview">
            <div class="book-preview__content">
              <div class="Heidelberg-Book" id="book-preview">

                <div
                  @click.stop="lazyLoading(index)"
                  class="Heidelberg-Page h-100"
                  :class="[wasVisible(index), backface(index)]"
                  v-for="(image, index) of images" :key="image + index">
                  <div class="book-preview__image" :style="'background-image: url(' + url(image, index) + ')'"></div>
                </div>

                <div v-if="showLookInside" class="book-preview__look">
                  <p class="book-preview__look-text h-text-blue-lighter-cl font-weight-bold">Look <span class="h-text-grey-cl-900">inside!</span></p>
                  <img src="/static/personal_book_app/img/arrow.svg" alt="arrow">
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  `
}